import { render, staticRenderFns } from "./EmpLgn.vue?vue&type=template&id=cb396946&"
import script from "./EmpLgn.vue?vue&type=script&lang=js&"
export * from "./EmpLgn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports